import { propOr } from 'ramda';
import styled from 'styled-components';

import { getScreenSize, getThemeColor, getThemeSize } from '../../../../utils/theme';

export const SaveButtonWrapper = styled.div`
  margin-top: ${({ marginTop }) => (marginTop ? `${marginTop}px` : '30px')};

  @media (max-width: ${getScreenSize(['medium'])}) {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: ${({ marginTopMobile }) => (marginTopMobile ? `${marginTopMobile}px` : '90px')};
  }
`;

export const InputWrapper = styled.div`
  flex-basis: ${propOr('100%', 'width')};
  width: ${propOr('100%', 'width')};
  max-width: ${propOr('100%', 'maxWidth')};
  margin-bottom: 10px;

  @media (max-width: ${getScreenSize(['medium'])}) {
    margin-bottom: 5px;
    flex-basis: ${propOr('100%', 'mobileWidth')};
    width: 100%;
    & input {
      font-size: ${getThemeSize(['middleSmallText'])};
    }
  }
`;

export const AdjustmentScoresTitle = styled.h2`
  font-size: ${getThemeSize(['largeText'])};
  color: ${getThemeColor(['violet'])};
`;

export const FormSection = styled.div`
  margin: 0;
  display: flex;
  & > div {
    min-width: 400px;
    margin-right: 40px;
  }
  @media (max-width: ${getScreenSize(['medium'])}) {
    flex-direction: column;

    & > div {
      min-width: 300px;
      margin: 0;
    }
  }
`;

export const ScoresSumTitle = styled.h3`
  margin: 20px 0 10px;
  color: ${getThemeColor(['violet'])};
`;

export const ScoreSectionTitle = styled.h4`
  margin: 20px 0 10px;
  font-size: ${getThemeSize(['bigText'])};
  color: ${getThemeColor(['violet'])};
`;
